<div
  class="deny-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="deny-request-title"
  appFocusTrap
>
  <header class="deny-modal__header flex align-center justify-between">
    <div class="flex align-center gap-12">
      <span class="deny-modal__header-icon" aria-hidden="true">
        <app-icon
          name="block"
          size="sm"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
      </span>
      <div>
        <h2 id="deny-request-title" class="deny-modal__title fs-16 fw-700 m-0">Deny Request</h2>
        <p class="fs-12 m-0 deny-modal__subtitle">{{ patientName() }}</p>
      </div>
    </div>
    <button
      type="button"
      class="deny-modal__close"
      (click)="cancel()"
      aria-label="Close deny request modal"
    >
      <app-icon
        name="close"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
    </button>
  </header>

  <div class="deny-modal__body">
    <div class="warning-banner flex align-start gap-12" role="alert" aria-live="assertive">
      <app-icon
        class="warning-banner__icon"
        name="warning"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <p class="fs-12 m-0">
        <strong>This action cannot be undone.</strong> The request will be closed and the patient
        will receive an email notification that their portal access request was denied.
      </p>
    </div>

    <fieldset class="denial-reasons" aria-required="true">
      <legend class="denial-reasons__legend fs-12 fw-600">
        Reason for denial
        <span class="required-asterisk" aria-hidden="true">*</span>
        <span class="sr-only">(required)</span>
      </legend>
      @for (reason of denialReasons; track trackByDenialReasonId($index, reason)) {
      <label
        class="denial-reason-row flex align-center gap-10"
        [class.denial-reason-row--selected]="denialReasonId() === reason.id"
      >
        <input
          type="radio"
          name="denialReason"
          [value]="reason.id"
          [checked]="denialReasonId() === reason.id"
          (change)="updateDenialReason(reason.id)"
          [attr.aria-label]="reason.label"
        />
        <span class="denial-reason-row__label">{{ reason.label }}</span>
      </label>
      }
    </fieldset>

    <div class="deny-note-section flex flex-col gap-8">
      <label class="deny-note-section__label fs-12 fw-600" for="deny-note">
        Internal note
        <span class="deny-note-section__optional fs-12">(optional)</span>
      </label>
      <textarea
        id="deny-note"
        class="deny-note"
        [value]="denyNoteText()"
        (input)="updateDenyNote($any($event.target).value)"
        placeholder="Add context for the audit log…"
      ></textarea>
    </div>

    @if (denyError()) {
    <p class="deny-error fs-12" role="alert">{{ denyError() }}</p>
    }

    <div class="deny-modal__actions flex justify-end align-center gap-12">
      <button type="button" class="secondary-button fw-600" (click)="cancel()">Cancel</button>
      <button
        type="button"
        class="danger-button fw-600 flex align-center gap-8"
        (click)="submit()"
        [disabled]="!canSubmit()"
      >
        <app-icon
          name="block"
          size="xs"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
        <span>{{ isDenyingRequest() ? 'Denying…' : 'Deny Request' }}</span>
      </button>
    </div>
  </div>
</div>
